import { mapState } from 'vuex'

export const reactions_mix = {
  inject: ['http'],
  data() {
    return {
      reaction: false,
      past_react_minus: [],
      past_react_plus: [],
    }
  },
  computed: {
    ...mapState({
      react_minus: state => state.react_minus,
      react_plus: state => state.react_plus
    }),
  },
  methods: {
    startReaction() {
      let type = (this.result.isSuccess ? 'react_plus' : 'react_minus');
      console.log(type)
      this.reaction_file = this.checkReaction(type);
      this.reaction = true;
    },
    stopReaction() {
      this.reaction = false;
    },
    checkReaction(type) {
      //console.log(type);
      let file = _.sample(this[type]);
      //console.log(file);
      if (_.difference(this[type], this['past_' + type]).length === 0) {
        this['past_' + type] = [];
      }
      if (_.indexOf(this['past_' + type], file) === -1) {
        //console.log('Добавляем и возвращаем реакцию');
        this['past_' + type].push(file);
        return file;
      } else {
        //console.log('Реакция уже была, запускаем заново');
        return this.checkReaction(type);
      }
    },
  }
};